<div class="space-y-2">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h4 class="text-sm font-semibold text-gray-800 dark:text-white/90">TE/Env · Envíos en fresco</h4>
    @if (puedeCrear) {
      <app-button size="sm" variant="outline" [disabled]="guardando" (btnClick)="agregar.emit()">{{ filas.length ? 'Agregar otro envío' : 'Agregar envío' }}</app-button>
    }
  </div>
  <div class="max-w-[44rem] overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700"
    appGrillaNav [tabSiguienteFila]="true" (pegarColumna)="pegar($event)">
    <table class="w-full text-sm">
      <thead class="bg-gray-50 text-left text-xs text-gray-500 dark:bg-gray-800 dark:text-gray-400">
        <tr>
          <th class="w-12 px-3 py-2 font-medium">#</th>
          <th class="w-44 px-2 py-2 font-medium">Fecha de envío</th>
          <th class="w-32 px-2 py-2 font-medium">Embriones</th>
          <th class="w-24 px-2 py-2"></th>
        </tr>
      </thead>
      <tbody>
        @for (fila of filas; track fila.id; let n = $index) {
          <tr class="border-t border-gray-100 dark:border-gray-700" [class.bg-warning-50]="fila.form.dirty" [formGroup]="fila.form">
            <td class="px-3 py-1 font-medium text-gray-600 dark:text-gray-300">{{ n + 1 }}</td>
            <td class="px-1 py-1">
              <app-label class="sr-only" [for]="fila.id + '-fecha'">Fecha de envío {{ n + 1 }}</app-label>
              <app-input-field [id]="fila.id + '-fecha'" type="date" formControlName="fecha_salida"
                [gridColumn]="'fecha_salida'" [gridRow]="n" className="h-9! px-2! py-1!"
                [error]="fila.form.controls.fecha_salida.invalid && fila.form.controls.fecha_salida.touched" />
            </td>
            <td class="px-1 py-1">
              <app-label class="sr-only" [for]="fila.id + '-embriones'">Embriones del envío {{ n + 1 }}</app-label>
              <app-input-field [id]="fila.id + '-embriones'" type="number" [min]="1" [step]="1" formControlName="nro_embriones"
                [gridColumn]="'nro_embriones'" [gridRow]="n" className="h-9! px-2! py-1! text-right!"
                [error]="fila.form.controls.nro_embriones.invalid && fila.form.controls.nro_embriones.touched" />
            </td>
            <td class="px-2 py-1 text-right">
              @if ((fila.salida && puedeEliminar) || (!fila.salida && puedeCrear)) {
                @if (fila.salida) {
                  <app-delete-trigger [title]="'Eliminar envío en fresco #' + (n + 1)" [disabled]="guardando" (clickDeleteEvent)="eliminar.emit(fila)" />
                } @else {
                  <app-button size="sm" variant="outline" [disabled]="guardando" (btnClick)="eliminar.emit(fila)">Quitar</app-button>
                }
              }
            </td>
          </tr>
          @if (fila.error) {
            <tr><td colspan="4" class="px-3 pb-1 text-xs text-error-600" role="alert">{{ fila.error }}</td></tr>
          }
        } @empty {
          <tr><td colspan="4" class="px-3 py-2 text-xs text-gray-500">Todavía no hay envíos en fresco.</td></tr>
        }
      </tbody>
    </table>
  </div>
</div>
